// 事件源 ID；v1.5.1 新增配置项；用于 SDK 子组件与宿主页面共用统计 App Key 和全局对象实例 window.mtstat 时，区分埋点事件上报的数据；默认值为 '0'，即表示该埋点事件为宿主上报；具体的值需要申请 申请邮件模板
const eventSource = 1029;
const h5DimensionEvents = new Set([
  'roboneo_viral_remake_card_click', 'roboneo_viral_remake_card_show',
  'roboneo_viral_remake_upload_click', 'roboneo_viral_remake_upload_complete', 'roboneo_viral_remake_run_click',
  'canvas_save_click', 'canvas_save_success', 'canvas_save_fail',
  'roboneo_history_collect_click', 'roboneo_history_collect_cancel', 'roboneo_history_content_delete', 'roboneo_viral_remake_tab_click',
]);

/**
 * 上报埋点事件；需求 8273 的共用事件默认标记 Web，H5 调用方显式覆盖，SDK 失败不影响业务。
 */
export function mtstatTrack(eventId: string, params: Record<string, any>) {
  try {
    // @ts-ignore
    window.mtstat?.track(eventId, h5DimensionEvents.has(eventId) ? { is_h5: '0', ...params } : params, () => {}, { eventSource });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[mtstat] track failed:', eventId, error);
    }
  }
}
